<app-loader></app-loader>
<div class="cancel-booking">
    <div class="find-outer">
        <h4>Cancel Booking</h4>
        <div class="close-icon">
            <img src="assets/images/export-close.svg" (click)="closeDialog()" alt="Close"/>
        </div>
    </div>
    <div class="parking-reservation">
        <p>Are you sure you want to cancel the Parking Booking? </p> 
        <div class="total-ammounts">
            <h5>${{totalAmount}}</h5>
        </div>
    </div>
    <p *ngIf="fetchModalData?.bookingPaymentMode != 2">Amount would be refunded back to the payment source.</p>
    <div class="cancel-outer1">
        <p-button class="mr-2" styleClass="p-button-confirm" label="Confirm" (onClick)="fetchModalData?.cancelType ==='recurring' ? recurringBookingCancel(): confirm()"></p-button>
        <p-button label="Cancel" styleClass="p-button-outlined-cancel p-button-outlined" (onClick)="closeDialog()"></p-button>
    </div>
</div>